(ns dre.modals.ai-summarization-usage.views
  (:require
   ["antd" :refer [Spin]]
   [dre.components.inputs :refer [checkbox]]
   [dre.components.form :refer [form form-item]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.ai-summarization-usage.events :as events]
   [dre.modals.modal-window :refer [modal-window]]
   [re-frame.core :as rf]))

(def component-name :modal-ai-summarization-usage)

(defn content
  []
  (let [data @(rf/subscribe [::events/state])
        loading? (= :loading (:state data))]
    [:div
     {:class component-name}
     [:> Spin
      {:spinning loading?
       :tip (when (:progress data)
              (str "Fetched " (min (:processed (:progress data)) (:total (:progress data))) "/" (:total (:progress data))))}
      [form
       [form-item
        {}
        [checkbox
         {:checked (get-in data [:settings :anonymize])
          :on-change #(rf/dispatch [::events/set-settings :anonymize (not (get-in data [:settings :anonymize]))])}
         [tr "Anonymize data"]]]]]
     [:div {:id :usage-export-progress-placeholder}]
     [:div {:id :usage-export-img-placeholder
            :style {:width "600px"}}]]))

(defn view
  []
  (fn []
    (let [data @(rf/subscribe [::events/state])
          loading? (= :loading (:state data))]
      [modal-window
       {:title "Export ai summarization usage data (max. 2000 records)"
        :content content
        :submit? true
        :submit-disabled? loading?
        :submit-text [tr "Export"]
        :on-submit #(rf/dispatch [::events/export {}])}])))